import { hydrate } from 'inferno-hydrate';
import { BrowserRouter } from 'inferno-router'
import { appFactory, doAllAsyncBefore, ApiClient } from './App';
import './index.scss';

hydrate(<BrowserRouter>{appFactory()}</BrowserRouter>, document.getElementById('app'))